module.exports = __webpack_public_path__ + "static/media/283ad817-0d84-4054-9587-b72b9a6008de.829ef656.JPG";